module.exports = __webpack_public_path__ + "static/littlecosybear-30d25ad081caac17e32c137dfea78ea3.jpeg";